const styles ={
  marginBottom: {
    marginBottom: '15px',
  },
};
export default styles;